import { ZsdFormIOModule } from './zsdformio/zsdformio.module';

/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuickCallListComponent } from './component/quickcalllist.component';
import { QuickCallDetailComponent } from './component/quickcalldetail.component';
import { QuickCallRoutingModule } from './quickcall-routing.module';
import { SharedModule } from '../../../../shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { SpinnerModule } from '../../../../shared/spinner/spinner.module';
import { InfiniteScrollModule } from '../../shared/module/infinite-scroll.module';
import { QuickCallDetailService } from './service/quickcalldetail.service';
import { CustomfieldsModule } from '../../shared/module/customfields.module';
import { ItemSelectionModule } from '../../shared/module/itemselection.module';
import { TinymceModule } from '../../../../shared/tinymce/tinymce.module';
import { FileUploadModule } from '../../../../shared/fileupload/fileupload.module';
import { QuickCallFieldsModule } from './quickcallfields.module';
import { QuickCallService } from './service/quickcalllist.service';



@NgModule({
    imports: [
        CommonModule,
        QuickCallRoutingModule,
        SharedModule,
        ReactiveFormsModule,
        SpinnerModule,
        InfiniteScrollModule,
        CustomfieldsModule,
        ItemSelectionModule,
        TinymceModule,
        FileUploadModule,
        ZsdFormIOModule,
        QuickCallFieldsModule
    ],
    declarations: [QuickCallListComponent, QuickCallDetailComponent],
    providers: [QuickCallService, QuickCallDetailService],
    exports: [QuickCallListComponent, QuickCallDetailComponent]
})
export class QuickCallModule { }
